/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Improve_Occupation_WhyInputs */

const en_us2_improve_occupation_why = /** @type {(inputs: Improve_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heavy work is training too. We count it.`)
};

const pt_br2_improve_occupation_why = /** @type {(inputs: Improve_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho pesado também é treino. Nós contamos.`)
};

const es_419_improve_occupation_why = /** @type {(inputs: Improve_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El trabajo pesado también es entrenamiento. Lo contamos.`)
};

const pt_pt2_improve_occupation_why = /** @type {(inputs: Improve_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho pesado também é treino. Nós contamo-lo.`)
};

const fr_fr2_improve_occupation_why = /** @type {(inputs: Improve_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un travail dur entraîne aussi. On le compte.`)
};

const de_de2_improve_occupation_why = /** @type {(inputs: Improve_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwere Arbeit ist auch Training. Wir rechnen sie mit.`)
};

const it_it2_improve_occupation_why = /** @type {(inputs: Improve_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anche il lavoro pesante è allenamento. Lo teniamo in conto.`)
};

/**
* | output |
* | --- |
* | "Heavy work is training too. We count it." |
*
* @param {Improve_Occupation_WhyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const improve_occupation_why = /** @type {((inputs?: Improve_Occupation_WhyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Improve_Occupation_WhyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_improve_occupation_why(inputs)
	if (locale === "es-419") return es_419_improve_occupation_why(inputs)
	if (locale === "pt-PT") return pt_pt2_improve_occupation_why(inputs)
	if (locale === "fr-FR") return fr_fr2_improve_occupation_why(inputs)
	if (locale === "de-DE") return de_de2_improve_occupation_why(inputs)
	if (locale === "it-IT") return it_it2_improve_occupation_why(inputs)
	return en_us2_improve_occupation_why(inputs)
});
export { improve_occupation_why as "improve.occupation.why" }